import { RecentVisit } from '@/types/recentlyVisited';

export const RECENTLY_VISITED_LIMIT = 12;

const isSameEntity = (a: RecentVisit, b: RecentVisit) => a.type === b.type && a.id === b.id;

// Newest first, one entry per entity (a revisit moves it to the front), capped so the oldest drops off.
export const addRecentVisit = (list: RecentVisit[], visit: RecentVisit) =>
  [visit, ...list.filter(item => !isSameEntity(item, visit))].slice(0, RECENTLY_VISITED_LIMIT);
